"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EItemType;
(function (EItemType) {
    EItemType["AXE"] = "AXE";
    EItemType["BAG"] = "BAG";
    EItemType["BOOTS"] = "BOOTS";
    EItemType["BOOTS_MAGIC"] = "BOOTS_MAGIC";
    EItemType["BOW"] = "BOW";
    EItemType["CAPE"] = "CAPE";
    EItemType["CIRCLET"] = "CIRCLET";
    EItemType["DAGGER"] = "DAGGER";
    EItemType["EVENT_ITEM"] = "EVENT_ITEM";
    EItemType["GLOVES"] = "GLOVES";
    EItemType["GLOVES_MAGIC"] = "GLOVES_MAGIC";
    EItemType["HAMMER"] = "HAMMER";
    EItemType["HELMET"] = "HELMET";
    EItemType["JACKET"] = "JACKET";
    EItemType["MACE"] = "MACE";
    EItemType["MATERIAL"] = "MATERIAL";
    EItemType["NECKLACE"] = "NECKLACE";
    EItemType["PANTS"] = "PANTS";
    EItemType["POLEARM"] = "POLEARM";
    EItemType["POTION"] = "POTION";
    EItemType["QUEST_ITEM"] = "QUEST_ITEM";
    EItemType["RING"] = "RING";
    EItemType["ROBE"] = "ROBE";
    EItemType["SCROLL"] = "SCROLL";
    EItemType["SHEET"] = "SHEET";
    EItemType["SHIELD"] = "SHIELD";
    EItemType["STAFF"] = "STAFF";
    EItemType["SWORD"] = "SWORD";
    EItemType["TOOL"] = "TOOL";
    EItemType["WAND"] = "WAND";
})(EItemType || (EItemType = {}));
exports.default = EItemType;
//# sourceMappingURL=EItemType.js.map